import { CaseSelector } from '@/modules/case-selector';

export default function CaseSelection() {
  return <CaseSelector />;
}
